import type { JSX } from "react";
import { useNavigate } from "react-router-dom";
import { Compass } from "lucide-react";

import { EmptyState } from "@vma/shared-ui";

export function NotFoundPage(): JSX.Element {
  const navigate = useNavigate();
  return (
    <main className="flex min-h-screen items-center justify-center bg-bg p-6">
      <div className="w-full max-w-md">
        <EmptyState
          title="404"
          description="你访问的页面不存在。回到工作台继续操作。"
          icon={<Compass size={28} />}
          action={
            <button
              type="button"
              onClick={() => {
                navigate("/dashboard");
              }}
              className="rounded-2xl bg-brand px-4 py-2 text-sm font-medium text-brand-fg shadow-xl transition hover:bg-brand/90"
            >
              回到工作台
            </button>
          }
        />
      </div>
    </main>
  );
}
